import { render, staticRenderFns } from "./candidatePersonal.vue?vue&type=template&id=47555f5f&"
import script from "./candidatePersonal.vue?vue&type=script&lang=js&"
export * from "./candidatePersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports